import { render, staticRenderFns } from "./NoProductsMessage.vue?vue&type=template&id=efa801a4&"
import script from "./NoProductsMessage.vue?vue&type=script&lang=js&"
export * from "./NoProductsMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports